import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleMobileMenu } from '@/features/ui/sliceMobileMenu';
import { useAppSelector } from '@/store/hooks';
import { cn } from '@/lib/utils';

const BurgerMenu = () => {
  const dispatch = useDispatch();
  const { isMobileMenu } = useAppSelector(({ ui }) => ({
    isMobileMenu: ui.isMobileMenu
  }));

  const toggle = () => {
    dispatch(toggleMobileMenu(!isMobileMenu));
  };

  return (
    <button
      type="button"
      className={cn(
        'w-[30px] relative cursor-pointer transition-transform duration-[400ms] border-0 bg-transparent mr-5 md:hidden',
        '[&_span]:w-full [&_span]:block [&_span]:bg-black [&_span]:h-[3px] [&_span]:my-[5px] [&_span]:mx-auto [&_span]:transition-all [&_span]:duration-[400ms] [&_span]:relative',
        isMobileMenu && [
          '-rotate-45',
          '[&_span:nth-child(1)]:translate-y-[8px]',
          '[&_span:nth-child(2)]:w-0',
          '[&_span:nth-child(3)]:rotate-90 [&_span:nth-child(3)]:-translate-x-[7px]'
        ]
      )}
      onClick={toggle}
    >
      <span />
      <span />
      <span />
    </button>
  );
};

export default BurgerMenu;
